import { create } from "zustand";
import {
  devtools,
  persist,
  createJSONStorage,
  type StateStorage,
} from "zustand/middleware";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
import { get, set, del } from "idb-keyval"; // can use anything: IndexedDB, Ionic Storage, etc.

// Custom storage object
const storage: StateStorage = {
  getItem: async (name: string): Promise<string | null> => {
    console.log(name, "has been retrieved");
    return (await get(name)) || null;
  },
  setItem: async (name: string, value: string): Promise<void> => {
    console.log(name, "with value", value, "has been saved");
    await set(name, value);
  },
  removeItem: async (name: string): Promise<void> => {
    console.log(name, "has been deleted");
    await del(name);
  },
};

export interface State {
  _hasHydrated: boolean;
  drawerOpen: boolean;
  drawerIsOpening: boolean;
  drawerIsClosing: boolean;
}

interface Actions {
  setHasHydrated: (state: boolean) => void;
  setDrawerOpen: (state: boolean) => void;
  setDrawerIsOpening: (state: boolean) => void;
  setDrawerIsClosing: (state: boolean) => void;
}

function initDrawerOpen() {
  const location = window.location;
  if (location.pathname.startsWith("/welcome")) return false;
  if (location.pathname.startsWith("/users")) return false;
  if (location.pathname.startsWith("/profile")) return false;
  if (location.pathname.startsWith("/stats")) return false;
  if (location.pathname.startsWith("/post")) return false;
  return window.innerWidth > 768 ? false : true;
}

const useMedspotStore = create<State & Actions>()(
  devtools(
    persist(
      (set): State & Actions => ({
        drawerOpen: initDrawerOpen(),
        drawerIsOpening: false,
        setDrawerIsOpening: (state) => {
          set({
            drawerIsOpening: state,
          });
        },
        drawerIsClosing: false,
        setDrawerIsClosing: (state) => {
          set({
            drawerIsClosing: state,
          });
        },
        setDrawerOpen: (open) => {
          set({
            drawerOpen: open,
            drawerIsOpening: open,
            drawerIsClosing: !open,
          });
        },
        _hasHydrated: false,
        setHasHydrated: (state) => {
          set({
            _hasHydrated: state,
          });
        },
      }),
      {
        name: "medspot-zustand-store",
        version: 2,
        storage: createJSONStorage(() => storage),
        onRehydrateStorage: (state) => {
          return () => state.setHasHydrated(true);
        },
        partialize: (state) =>
          Object.fromEntries(
            Object.entries(state).filter(
              ([key]) =>
                ![
                  "drawerOpen",
                  //  other shit
                ].includes(key),
            ),
          ),
      },
    ),
  ),
);

export default useMedspotStore;
